/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Add_ContentInputs */

const en_mobile_add_content = /** @type {(inputs: Mobile_Add_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Content`)
};

const es_mobile_add_content = /** @type {(inputs: Mobile_Add_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar contenido`)
};

/**
* | output |
* | --- |
* | "Add Content" |
*
* @param {Mobile_Add_ContentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_add_content = /** @type {((inputs?: Mobile_Add_ContentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Add_ContentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_add_content(inputs)
	return en_mobile_add_content(inputs)
});